module.exports = __webpack_public_path__ + "img/icon-page-footer-logo-huygens.e7ed1826.svg";